export enum queryKey {
  account = 'getAccount',
  cad_result = 'getCadResult',
  cad_rules = 'getCadRules',
  devices = 'getDevices',
  qms = 'getQMS',
  qms_detail = 'getQMSDetail',
  qms_profile = 'getQMSProfile',
  filter_management = 'getFilterManagement',
  filter_tree = 'getFilterTree',
  institution = 'getInstitution',
  detail_institution = 'getDetailInstitution',
  layout_report = 'getLayouts',
  deviceStatistics = 'getDeviceStatistics',
  deviceStatisticsAll = 'getDeviceStatisticsAll',
  deviceStatistics_interval = 'getDeviceStatisticsInterval',
  orders = 'getOrders',
  orderDetail = 'getOrderDetail',
  orderWorklist = 'getOrderWorklist',
  orders_interval = 'getOrdersInterval',
  orderWorklist_interval = 'getOrderWorklistInterval',
  assigns = 'getAssigns',
  assigns_interval = 'getAssignsInterval',
  procedure = 'getProcedure',
  procedure_group = 'getProcedureGroup',
  bodyPart = 'getBodyPart',
  department = 'getDepartment',
  reports = 'getReports',
  approver = 'getApprover',
  roles = 'getRoles',
  share = 'getShare',
  share_detail = 'getShareDetail',
  studies_interval = 'getStudiesInterval',
  template_report = 'getTemplates',
  template_detail = 'getTemplate',
  userInfo = 'userInfo',
  visited_patients = 'getVisitedPatients',
  groups = 'getGroups',
  dashboard_exam_by_radiologist = 'getDashboardExamByRadiologist',
  dashboard_perform_by_radiologist = 'getDashboardPerformByRadiologist',
  patients = 'getPatients',
  study_detail = 'getStudyDetail',
  create_attachment = 'createAttachment',
  HISOrders = 'getHISOrders',
  HISVisitOrders = 'getHISVisitOrders',
  share_infinite = 'getShareInfinite',
  element = 'getElement',
  element_detail = 'getElementDetail',
  structure_report = 'getStructureReport',
  structure_report_detail = 'getStructureReportDetail',
  orderNotes = 'getOrderNotes',
  consultations = 'getConsultations',
  consultationDetail = 'getConsultationDetail',
  consultation_note = 'getConsultationNote',
  downloadImageElement = 'downloadImageElement',
  process_history = 'getProcessHistory',
  update_profile = 'updateProfile',
  esign_history = 'getEsignHistory',
  full_esign_history_by_order = 'getFullEsignHistoryByOrder',
  print = 'getPrintData',
  order_report = 'getOrderReport',
  study_latest_report = 'getStudyLatestReport',
  latest_report_by_order = 'getLatestReportByOrder',
  report_by_version_id = 'getReportByVersionId',
  report_detail = 'getReportDetail',
  report_versions = 'getReportVersions',
  test_information = 'getTestInformation',
}
